/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class DishPosApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.dish-pos', {
      categories: [GstplnAppCategory.Pos],
      underPaywall: false,
      hasDarkIcon: false,
      configComponentImportFnc: () => import('@/components/apps/dish-pos/SettingsDialog.vue'),
    });
  }
}
